import styled from "styled-components";

const VSpace = styled.div`
    width: 100%;
    height: ${(p) => p.size || 0}px;
`;

export default VSpace;